import { padTwoDigits } from '@federa/const/two-digit-pad';
import { TIME_UNITS } from '@federa/const/time-units';
import { COUNTDOWN_LABEL_AUCTION_CLOSED } from '@federa/const/countdown-label-values';
import { countdownClockParts, elapsedClockParts } from '@federa/const/elapsed-clock-parts';

export function formatCountdown(remainingSeconds: number | null | undefined): string {
	if (remainingSeconds == null) return '';
	if (!Number.isFinite(remainingSeconds) || remainingSeconds <= 0) return COUNTDOWN_LABEL_AUCTION_CLOSED;

	if (remainingSeconds >= TIME_UNITS.DAY_S) {
		const { days, hours } = countdownClockParts(remainingSeconds);
		return `${days}d ${padTwoDigits(hours)}h`;
	}
	if (remainingSeconds >= TIME_UNITS.HOUR_S) {
		const { hours, minutes } = elapsedClockParts(remainingSeconds);
		return `${hours}h ${padTwoDigits(minutes)}m`;
	}
	if (remainingSeconds >= TIME_UNITS.MINUTE_S) {
		const minutes = Math.floor(remainingSeconds / TIME_UNITS.MINUTE_S);
		const seconds = Math.floor(remainingSeconds % TIME_UNITS.MINUTE_S);
		return `${minutes}m ${padTwoDigits(seconds)}s`;
	}
	return `${Math.floor(remainingSeconds)}s`;
}
